const HeaderContent = [
  {
    parentMenu: "Testimonial",
    parentPath: "/for-employers",
    scrollId: "offer",
    // parentIcon: <i className="fas fa-chevron-down" />,
    // subParentMenu: [
    //   {
    //     subMenu: "Freelancer",
    //     subPath: "/",
    //     childMenu: [
    //       {
    //         menu: "Freelancer",
    //         path: "/",
    //       },
    //       {
    //         menu: "Freelancer Details",
    //         path: "/",
    //       },
    //     ],
    //   },
    //   {
    //     subMenu: "Dashboard",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "My Profile",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Company Details",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Projects",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Favourites",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Membership",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Milestones",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Chats",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Review",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Payments",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Verify Identity",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Settings",
    //     subPath: "/profile-setting",
    //   },
    // ],
  },
  {
    parentMenu: "Pehal Exceptionals",
    parentPath: "/for-freelancer",

    // parentIcon: <i className="fas fa-chevron-down" />,
    // subParentMenu: [
    //   {
    //     subMenu: "Freelancer",
    //     subPath: "/",
    //     childMenu: [
    //       {
    //         menu: "Projects",
    //         path: "/",
    //       },
    //       {
    //         menu: "Project Details",
    //         path: "/",
    //       },
    //     ],
    //   },
    //   {
    //     subMenu: "Dashboard",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "My Profile",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Freelancer Details",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Projects",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Favourites",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Membership",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Change Password",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Chats",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Review",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Payments",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Verify Identity",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Settings",
    //     subPath: "/",
    //   },
    // ],
  },
  {
    parentMenu: "Use Cases",
    parentPath: "/for-freelancer",
    scrollId: "approach",
    // parentIcon: <i className="fas fa-chevron-down" />,
    // subParentMenu: [
    //   {
    //     subMenu: "About us",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Starter Page",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "404 Page",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Invoices",
    //     subPath: "/",
    //     childMenu: [
    //       {
    //         menu: "Invoices",
    //         path: "/",
    //       },
    //       {
    //         menu: "Invoice View",
    //         path: "/",
    //       },
    //     ],
    //   },
    //   {
    //     subMenu: "Login",
    //     subPath: "/login",
    //   },
    //   {
    //     subMenu: "Register",
    //     subPath: "/register",
    //   },
    //   {
    //     subMenu: "Onboard Screen",
    //     subPath: "/onboard-screen",
    //   },
    //   {
    //     subMenu: "Forgot Password",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Change Password",
    //     subPath: "/",
    //   },
    // ],
  },
  {
    parentMenu: "About Us",
    parentPath: "/about-us",
  },
  {
    parentMenu: "Contact Us",
    parentPath: "/",
    scrollId: "register",
    // parentIcon: <i className="fas fa-chevron-down" />,
    // subParentMenu: [
    //   {
    //     subMenu: "Home",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Home-1",
    //     subPath: "/",
    //   },
    //   {
    //     subMenu: "Home-2",
    //     subPath: "/",
    //   },
    // ],
  },
  // {
  //   parentMenu: "Blog",
  //   parentPath: "/for-freelancer",
  //   parentIcon: <i className="fas fa-chevron-down" />,
  //   subParentMenu: [
  //     {
  //       subMenu: "Blog List",
  //       subPath: "/",
  //     },
  //     {
  //       subMenu: "Blog Grid",
  //       subPath: "/",
  //     },
  //     {
  //       subMenu: "Blog Details",
  //       subPath: "/",
  //     },
  //   ],
  // },
  // {
  //   parentMenu: "Admin",
  // },
];

export default HeaderContent;
